import {
  useState,
  useEffect,
  FC,
  ReactNode,
  createContext,
  useCallback,
} from 'react';
import { debounce } from 'utils';

export const breakpoints = {
  mobile: 768,
  tablet: 1280,
};
export type ScreenType = 'mobile' | 'tablet' | 'desktop';

const ResponsiveContext = createContext<ScreenType | undefined>(undefined);

const ResponsiveProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [screenType, setScreenType] = useState<ScreenType>();
  const calculateScreenType = useCallback((): ScreenType => {
    const width = window.innerWidth;
    if (width < breakpoints.mobile) return 'mobile';
    else if (width >= breakpoints.mobile && width < breakpoints.tablet)
      return 'tablet';
    else return 'desktop';
  }, []);
  const handleResize = useCallback(() => {
    const newScreenType = calculateScreenType();
    if (newScreenType !== screenType) {
      setScreenType(newScreenType);
    }
  }, []);
  useEffect(() => {
    const debouncedResizeHandler = debounce(handleResize, 300);
    window.addEventListener('resize', debouncedResizeHandler);
    handleResize();
    return () => {
      window.removeEventListener('resize', debouncedResizeHandler);
    };
  }, []);
  return (
    <ResponsiveContext.Provider value={screenType || 'desktop'}>
      {children}
    </ResponsiveContext.Provider>
  );
};
export { ResponsiveContext, ResponsiveProvider };
